module.exports = __webpack_public_path__ + "static/logoandtxt-ae40b3adc1fd8d5aacfbdefcf5801615.png";